// extracted by extract-css-chunks-webpack-plugin
module.exports = {"error_box":"error_box-2dAhibGL","error":"error-1kUoxVSt"};